import { useContext, useEffect } from "react";
import { I18nContext } from "../../context/i18n.context";
import { GetlifeContext } from "../../context/GetLifeContext.context";

const IdCardBiometryController = () => {
    const {
        leadId,
        setShowFooter
    } = useContext(GetlifeContext);

    const {
        state: { translate },
    } = useContext(I18nContext);

    useEffect(() => {
        setShowFooter(false);
    }, []);

    return {
        translate,
        leadId
    }
}

export default IdCardBiometryController;
